import { render } from "./LegalDocument.vue?vue&type=template&id=b3a9901a&scoped=true"
import script from "./LegalDocument.vue?vue&type=script&lang=js"
export * from "./LegalDocument.vue?vue&type=script&lang=js"

import "./LegalDocument.vue?vue&type=style&index=0&id=b3a9901a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3a9901a"]])

export default __exports__